module.exports = __webpack_public_path__ + "img/natural-icon.788cc2af.svg";